import logo from './logo.jpg';
import './App.css';
import React, { useState, useEffect } from 'react';
import Inicio from './componentes/Inicio';
import AgregarEntrada from './componentes/AgregarEntrada';
import AgregarSalida from './componentes/AgregarSalida';
import GetSalida from './componentes/GetSalida';
import GetEntrada from './componentes/GetEntrada';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CrearProducto from './componentes/CrearProducto';
import GetProductos from './componentes/GetProductos';
import FiltrarEgresos from './componentes/FiltrarEgresos';
import FinalizarCompra from './componentes/FinalizarCompra.jsx';
import Pedidos from './componentes/Pedidos.jsx';
import GenerarFactura from './componentes/GenerarPDF.jsx';
import CrearUsuarios from './componentes/CrearUsuarios.jsx';
import GetTarjetas from './componentes/GetTarjetas.jsx';
import BuscarTarjeta from './componentes/BuscarTarjeta.jsx';
import { useAuth0 } from '@auth0/auth0-react';
import { useQuery, gql } from '@apollo/client';
import EstadisticaMensual from './componentes/EstadisticaMensual.jsx';
import QRScanner from './componentes/QRScanner.jsx';
import MonitorCliente from './componentes/MonitorCliente.jsx';
import VerificaryAgregar from './componentes/VerificaryAgregar.jsx';
import GetProductosLegumbre from './componentes/GetProductosLegumbre.jsx';
import MostrarCarrito from './componentes/MostrarCarrito.jsx';
import BuscarAgregar from './componentes/BuscarAgregar.jsx';
import ProductosMedicina from './componentes/ProductosMedicina.jsx';
import ProductosSinCodigo from './componentes/ProductosSinCodigo.jsx';
import CierreCaja from './componentes/CierreCaja.jsx';
import FiltrarInventario from './componentes/FiltrarInventario.jsx';
import ProductosVendidos from './componentes/ProductosVendidos.jsx';
import PesoBascula from './componentes/PesoBascula.jsx';
import CajaAuxiliar from './componentes/CajaAuxiliar.jsx'
import Ultimos10Pedidos from './componentes/Ultimos10Pedidos.jsx';
import ProductosAgotados from './componentes/ProductosAgotados.jsx';
import FacturaCliente from './componentes/FacturaCliente.jsx';
import FinalizarCompra1 from './componentes/FinalizarCompra1.jsx';
import VendidosEstadisticas from './componentes/VendidosEstadisticas.jsx';
import HistoricoUltimos30dias from './componentes/HistoricoUltimos30dias.jsx';
import ProductoPromocion from './componentes/ProductosPromocion.jsx';
import ProductosJson from './componentes/ProductosJson.jsx';
import ConsultorDePrecios from './componentes/ConsultorDePrecios.jsx'
import CajaAuxiliar2 from './componentes/CajaAuxiliar2.jsx'
import Proveedores from './componentes/Proveedores.jsx'
import PreciosProveedores from './componentes/PreciosProveedores.jsx'
const GET_USUARIOS = gql`
  query getUsuarios {
    getUsuarios {
      _id
      nombre
      rol
      contacto
      correo
      direccion
    }
  }
`;

function App() {
  const { user, isAuthenticated, loginWithRedirect } = useAuth0();
  const { loading, error, data } = useQuery(GET_USUARIOS);
  const [isAdmin, setIsAdmin] = useState(false);

/*  useEffect(() => {
    if (!loading && isAuthenticated && data && user) {
      // Correos permitidos
      const allowedEmails = ["yarianyandrea2018@gmail.com", "leonbuitrago66perez@gmail.com"];

      // Verificar si el usuario actual tiene el rol de administrador y está en la lista
      const isAdminUser = data.getUsuarios.some(
        (usuario) => usuario.correo === user.email && 
                     usuario.rol === "administrador" && 
                     allowedEmails.includes(user.email)
      );
      setIsAdmin(isAdminUser);
    }
  }, [loading, data, isAuthenticated, user]);

  if (loading) return <p>Esperando resultados...</p>;
  if (error) return <p>Error</p>;

  // Verificar autenticación y permisos de administrador
  if (!isAuthenticated || !isAdmin) {
    return (
      <div className="alert alert-success" role="alert">
        No tienes permisos para acceder a esta página.
        &nbsp;
        <button className='btn btn-success' onClick={() => loginWithRedirect()}>
          Ingresar
        </button>
      </div>
    );
  }*/

  return (
    <div className="">
      <BrowserRouter>
        <Routes>
          <Route path="/inicio" element={<Inicio />} />
          <Route path="/ventas" element={<AgregarEntrada />} />
          <Route path="/compras" element={<AgregarSalida />} />
          <Route path="/ver-egresos" element={<GetSalida />} />
          <Route path="/ver-ingresos" element={<GetEntrada />} />
          <Route path="/lector-qr" element={<QRScanner />} />
          <Route path="/verificar-y-agregar" element={<VerificaryAgregar />} />
          <Route path="/1" element={<GetProductos />} />
          <Route path="/crear-product" element={<CrearProducto />} />
          <Route path="/finalizar-compra" element={<FinalizarCompra />} />
          <Route path='/finalizar-compra-1' element={<FinalizarCompra1/>} />
          <Route path='/pedidos' element={<Pedidos />} />
          <Route path='/pdf' element={<GenerarFactura />} />
          <Route path='/crear-usuario' element={<CrearUsuarios />} />
          <Route path='/estadisticas' element={<EstadisticaMensual />} />
          <Route path='/tarjetas' element={<GetTarjetas />} />
          <Route path='/search' element={<BuscarTarjeta />} />
          <Route path='/monitor-cliente' element={<MonitorCliente />} />
          <Route path='/' element={<GetProductosLegumbre />} />
          <Route path='/ver-carrito' element={<MostrarCarrito />} />
          <Route path='/buscar-y-agregar' element={<BuscarAgregar />} />
          <Route path='/medicina' element={<ProductosMedicina />} />
          <Route path='/productos-sin-codigo' element={<ProductosSinCodigo />} />
          <Route path='/1421' element={<CierreCaja />} />
          <Route path='/filtrar-inventario' element={<FiltrarInventario />} />
           <Route path='/productos-vendidos' element={<ProductosVendidos/>} />
          <Route path='/bascula' element={<PesoBascula/>} /> 
          <Route path='/caja-auxiliar' element={<CajaAuxiliar/>} /> 
          <Route path='/caja-auxiliar2' element={<CajaAuxiliar2/>} /> 
          <Route path='/10pedidos' element={<Ultimos10Pedidos/>} /> 
           <Route path='/agotados' element={<ProductosAgotados/>} /> 
          <Route path='/factura/:numeroPedido' element={<FacturaCliente/>} /> 
          <Route path='/ventas-estadisticas' element={<VendidosEstadisticas/>}/>
          <Route path='/historico' element={<HistoricoUltimos30dias/>}/>
          <Route path='crear-promocion' element={<ProductoPromocion/>}/>
          <Route path='json' element={<ProductosJson/>}/>
          <Route path='/consultor-precios' element={<ConsultorDePrecios/>}/>
          <Route path='proveedores' element={<Proveedores/>}/>
          <Route path='precio-proveedores' element={<PreciosProveedores/>}/>
          
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
